import useSWR from 'hooks/useSWR';

export default ({ ecards_id, company_id }) =>
  useSWR({
    url: `/v1/revenues/e_cards/${ecards_id}?company_id=${company_id}`,
    swrOptions: {
      if: Boolean(ecards_id && company_id)
    }
  });
